export default '/pricing/deals-lp-1002';
